module.exports = __webpack_public_path__ + "img/lamp_fungus.802dc053.png";